export class DemandAddSupplierRequest {
    constructor(public readonly supplierCompanyId: string, public readonly contactId: string) {}
}
